/**
 * DIBAI 18K — Dicen de DIBAI
 * assets/dicen-dibai.js  v1.0.0
 */
(function () {
  'use strict';

  function init(root) {
    const track   = root.querySelector('[data-ddb-track]');
    const slides  = Array.from(root.querySelectorAll('[data-ddb-slide]'));
    const dots    = Array.from(root.querySelectorAll('[data-ddb-dot]'));
    const prev    = root.querySelector('[data-ddb-prev]');
    const next    = root.querySelector('[data-ddb-next]');
    const current = root.querySelector('[data-ddb-current]');

    if (!slides.length) return;

    let idx    = 0;
    let timer  = null;

    function go(n) {
      const old = idx;
      idx = ((n % slides.length) + slides.length) % slides.length;
      if (idx === old) return;

      // Slides
      slides[old].classList.remove('ddb-slide--active');
      slides[old].setAttribute('aria-hidden', 'true');
      slides[idx].classList.add('ddb-slide--active');
      slides[idx].setAttribute('aria-hidden', 'false');

      // Dots
      dots[old]?.classList.remove('ddb-dot--active');
      dots[old]?.setAttribute('aria-selected', 'false');
      dots[idx]?.classList.add('ddb-dot--active');
      dots[idx]?.setAttribute('aria-selected', 'true');

      // Contador
      if (current) current.textContent = String(idx + 1);

      // Ajustar altura del track al slide activo
      if (track) track.style.minHeight = slides[idx].offsetHeight + 'px';
    }

    function startAuto() {
      stopAuto();
      timer = setInterval(() => go(idx + 1), 5000);
    }

    function stopAuto() {
      clearInterval(timer);
    }

    // Altura inicial
    requestAnimationFrame(() => {
      if (track && slides[0]) track.style.minHeight = slides[0].offsetHeight + 'px';
    });

    // Eventos
    prev?.addEventListener('click', () => { go(idx - 1); startAuto(); });
    next?.addEventListener('click', () => { go(idx + 1); startAuto(); });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        go(parseInt(dot.dataset.ddbDot, 10));
        startAuto();
      });
    });

    // Teclado
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { go(idx + 1); startAuto(); }
      if (e.key === 'ArrowLeft')  { go(idx - 1); startAuto(); }
    });

    // Touch swipe
    let startX = 0;
    root.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { go(diff > 0 ? idx + 1 : idx - 1); startAuto(); }
    }, { passive: true });

    // Pausar al hover
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);

    startAuto();
  }

  function initAll() {
    document.querySelectorAll('.dicen-dibai-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.dicen-dibai-wrapper') || e.target.closest('.dicen-dibai-wrapper');
    if (root) init(root);
  });
})();
